import { createFileRoute, Link } from '@tanstack/react-router'
import { Calendar, Clock, Mail, Wrench } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

export const Route = createFileRoute('/maintenance')({
  component: MaintenancePage,
})

function MaintenancePage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background to-muted/30 flex items-center justify-center p-4 md:p-8">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 w-full max-w-2xl">
        <Card className="border-none shadow-2xl bg-card/80 backdrop-blur-sm">
          <CardHeader className="text-center pb-2">
            <div className="mx-auto mb-6 p-4 rounded-full bg-blue-500/10">
              <Wrench className="w-12 h-12 text-blue-500" />
            </div>
            <CardTitle className="text-3xl md:text-4xl font-bold tracking-tight">
              Under Maintenance
            </CardTitle>
            <CardDescription className="text-lg mt-2">We'll be back soon!</CardDescription>
          </CardHeader>
          <CardContent className="text-center space-y-6 pt-4">
            <p className="text-muted-foreground text-sm md:text-base leading-relaxed">
              We're currently performing scheduled maintenance to improve our services. We apologize
              for any inconvenience and appreciate your patience.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4">
              <div className="bg-muted/50 rounded-lg p-4 text-left">
                <div className="flex items-center gap-2 mb-2">
                  <Clock className="w-4 h-4 text-blue-500" />
                  <span className="font-medium text-sm">Estimated Time</span>
                </div>
                <p className="text-sm text-muted-foreground">
                  We're working to get everything back up as quickly as possible.
                </p>
              </div>
              <div className="bg-muted/50 rounded-lg p-4 text-left">
                <div className="flex items-center gap-2 mb-2">
                  <Calendar className="w-4 h-4 text-purple-500" />
                  <span className="font-medium text-sm">Maintenance Window</span>
                </div>
                <p className="text-sm text-muted-foreground">
                  This is a scheduled maintenance. Thank you for your understanding.
                </p>
              </div>
            </div>

            <div className="pt-4 border-t">
              <p className="text-sm text-muted-foreground mb-4">Need help or have questions?</p>
              <div className="flex flex-col gap-3 max-w-sm mx-auto">
                <Button variant="outline" className="w-full">
                  <Mail className="w-4 h-4 mr-2" />
                  Contact Support
                </Button>
              </div>
            </div>

            <div className="pt-4">
              <Button asChild>
                <Link to="/">Return to Home</Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
